/* Giamarè Portofino — Passwort / Zugang
   Minimaler Vanilla-JS. Sanfter Wechsel Feld → „Benvenuto.“ OHNE Seitenwechsel.

   Technik: verstecktes <iframe> als Ziel des Formulars.
   Das native Absenden landet im iframe — die Hauptseite navigiert NIE.
   Die E-Mail wird von Shopify ganz normal verarbeitet (kein fetch, kein
   Umweg → CSP-unabhaengig). Laed das iframe fertig, erscheint „Benvenuto.“.

   Ohne JS: normales Absenden, Seite laedt neu, „Benvenuto.“ wird
   server-seitig gerendert (Fallback in main-password.liquid). */
(function () {
  var root = document.querySelector('[data-pw]');
  if (!root) return;

  /* Autoplay-Absicherung: blockiert der Browser, bleibt das Poster stehen */
  var video = root.querySelector('video.pw__video');
  if (video) {
    var t = video.play();
    if (t && typeof t.catch === 'function') { t.catch(function () {}); }
  }

  var access = root.querySelector('[data-pw-access]');
  var live = root.querySelector('[data-pw-live]');
  var welcome = root.querySelector('[data-pw-welcome]');
  var form = root.querySelector('.pw__form');
  if (!access || !live || !welcome || !form) return;

  var input = form.querySelector('#pwEmail');
  var enter = form.querySelector('.pw__enter');

  /* Verstecktes iframe: nimmt die Formular-Antwort auf, die Seite bleibt stehen */
  var sink = document.createElement('iframe');
  sink.name = 'pw_sink_' + Date.now();
  sink.setAttribute('aria-hidden', 'true');
  sink.setAttribute('tabindex', '-1');
  sink.style.cssText = 'position:absolute;left:-9999px;width:0;height:0;border:0;';
  document.body.appendChild(sink);
  form.setAttribute('target', sink.name);

  var submitted = false;
  var done = false;

  function reveal() {
    if (done) return;
    done = true;
    /* Hoehe festhalten, damit kein Layoutsprung entsteht */
    access.style.minHeight = access.offsetHeight + 'px';
    live.classList.add('is-leaving');
    window.setTimeout(function () {
      live.hidden = true;
      welcome.hidden = false;
      welcome.classList.add('is-entering');
    }, 260);
  }

  /* Feuert das iframe sein load-Event, wechseln wir sofort. Darf Shopify die
     Antwort wegen X-Frame-Options NICHT im iframe rendern, bleibt load aus —
     dann greift der Timer unten. Der POST selbst erreicht Shopify in beiden
     Faellen, die E-Mail wird also gespeichert. */
  sink.addEventListener('load', function () {
    if (submitted) { reveal(); }
  });

  form.addEventListener('submit', function () {
    /* ungueltige E-Mail: der Browser blockt das Absenden und zeigt die
       native Validierung — das submit-Event feuert dann gar nicht. */
    if (input && !input.checkValidity()) { return; }

    submitted = true;
    /* KEIN preventDefault — natives Absenden geht ins iframe, kein Reload */
    if (enter) {
      enter.classList.add('is-busy');
      /* Button erst nach dem Absende-Tick sperren (verhindert Doppel-Submit,
         ohne das laufende Absenden abzubrechen) */
      window.setTimeout(function () { enter.disabled = true; }, 0);
    }
    /* Rueckmeldung zeitgesteuert — unabhaengig davon, ob das iframe die
       Antwort rendern darf. reveal() ist idempotent (done-Flag). */
    window.setTimeout(reveal, 700);
  });
})();
